// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro_head_image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.intro_head_image .intro_img_mid {
  width: 100%;
}
@media (min-width: 481px) {
  .intro_head_image .intro_img_mid {
    width: 50%;
  }
}
.intro_head_image .intro_img_small {
  width: 64px;
}
@media (max-width: 1440px) and (min-width: 481px) {
  .intro_head_image .intro_img_small {
    width: 108px;
  }
}
.intro_head_image .intro_img_big {
  width: 220px;
}
@media (max-width: 1440px) and (min-width: 481px) {
  .intro_head_image .intro_img_big {
    width: 330px;
  }
}
.intro_head_image .intro_desc {
  font-size: 14px;
  margin-top: 8px;
}
@media (max-width: 1440px) and (min-width: 481px) {
  .intro_head_image .intro_desc {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/HTT/HTT.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAIE;EACE,WAAA;AAFJ;ACGI;EDFF;IAGI,UAAA;EAAJ;AACF;AAGE;EACE,WAAA;AADJ;ACVI;EDUF;IAGI,YAAA;EACJ;AACF;AAEE;EACE,YAAA;AAAJ;AClBI;EDiBF;IAGI,YAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,eAAA;AACJ;AC3BI;EDwBF;IAII,eAAA;EAGJ;AACF","sourcesContent":["@import \"styles/variables\";\n@import \"styles/mixins\";\n\n.intro_head_image {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  \n  .intro_img_mid {\n    width: 100%;\n    @include TabletAndPC() {\n      width: 50%;\n    }\n  }\n\n  .intro_img_small {\n    width: 64px;\n    @include Tablet() {\n      width: 108px;\n    }\n  }\n\n  .intro_img_big {\n    width: 220px;\n    @include Tablet() {\n      width: 330px;\n    }\n  }\n\n  .intro_desc {\n    font-size: 14px;\n    margin-top: 8px;\n    @include Tablet() {\n      font-size: 16px;\n    }\n  }\n}","@mixin Mobile() {\n    @media (max-width: 480px) {\n        @content;\n    }\n}\n@mixin Tablet() {\n    @media (max-width: 1440px) and (min-width: 481px) {\n        @content;\n    }\n}\n@mixin TabletAndPC() {\n    @media (min-width: 481px) {\n        @content;\n    }\n}\n@mixin TabletVertical() {\n    @media (max-width: 768px) and (orientation: portrait) {\n        @content;\n    }\n}\n@mixin TabletHorizontal() {\n    @media (max-width: 768px) and (orientation: landscape) {\n        @content;\n    }\n}\n@mixin PC() {\n    @media (min-width: 769px) {\n        @content;\n    }\n}\n@mixin LowHeight() {\n    @media (max-height: 700px) {\n        @content;\n    }\n}\n@mixin LowHeightVertical() {\n    @media (max-height: 700px) and (min-width: 769px) {\n        @content;\n    }\n}\n@mixin HighHeight() {\n    @media (min-height: 701px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
